



























import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
@Component
export default class ContentBlock extends Vue {
	@Prop() private title!: string
	@Prop() private titleIcon!: string
	@Prop({
		type: Array,
		required: false,
		default: () => {
			return []
		}
	})
	private listData!: object
	@Emit()
	private 'on-item-click' (item: any) {
		return item
	}

	private onListItemClick (item: any) {
		this['on-item-click'](item)
	}
}
